// orgProfile.ts — the member-facing profile of the organisation that provided this
// person's access (a charity, employer, EAP...). Read via the SECURITY DEFINER RPC
// my_org_profile(), which returns ONLY the safe, member-facing fields for the caller's
// own org (never billing / cohort). Surfaced in the "Get help" page (CrisisSupport).
//
// Returns null for B2C / ungrouped users, or when the org has filled in nothing worth
// showing — so the org card simply doesn't appear unless there's real content.
import { supabase } from './supabaseClient';

export type OrgProfile = {
  name: string | null;
  website_url: string | null;
  support_phone: string | null;
  member_message: string | null;
};

export async function fetchOrgProfile(): Promise<OrgProfile | null> {
  const sb = supabase();
  if (!sb) return null;
  try {
    const { data, error } = await sb.rpc('my_org_profile');
    if (error || !Array.isArray(data) || !data.length) return null;
    const r = data[0] as OrgProfile;
    // Show the card only when there is something beyond the bare name.
    if (!r || (!r.member_message && !r.website_url && !r.support_phone)) return null;
    return r;
  } catch {
    return null;
  }
}
